import DateTime from '../dateTime/DateTime';
export default class DefaultEqualityComparer {
    static equal(obj1, obj2) {
        if (obj1 === undefined || obj2 === undefined || obj1 === null || obj2 === null) {
            return obj1 === obj2;
        }
        else if (typeof obj1.equals === 'function') {
            return obj1.equals(obj2);
        }
        else if (typeof obj2.equals === 'function') {
            return obj2.equals(obj1);
        }
        else if (DateTime.isDate(obj1) && DateTime.isDate(obj2)) {
            return DateTime.equal(obj1, obj2);
        }
        else if (obj1 === obj2) {
            return true;
        }
        else {
            return false;
        }
    }
    ;
}
//# sourceMappingURL=DefaultEqualityComparer.js.map